/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Customer_Refund_DescInputs */

const vi_customer_refund_desc = /** @type {(inputs: Customer_Refund_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Khách đang có tiền dư ${i?.amount}. Lập phiếu chi trả lại tiền cho khách; sổ công nợ ghi dòng "Hoàn tiền".`)
};

/**

* @param {Customer_Refund_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_refund_desc = /** @type {((inputs: Customer_Refund_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Refund_DescInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_refund_desc(inputs)
});